export const LOGIN_PATH = `/`
export const LOGOUT_PATH = `/auth/logout`

export const CLIENT_TOKEN_KEY = 'mmnts.client-token'
